import React from 'react';
import './Loader.css';

const Loader = ({ fullScreen = false, size = 'medium' }) => {
  const loaderClasses = `loader ${fullScreen ? 'loader-fullscreen' : ''} loader-${size}`;

  return (
    <div className={loaderClasses}>
      <div className="loader-container">
        <img 
          src="/images/logo.png" 
          alt="Loading..." 
          className="loader-logo"
        />
        <div className="loader-spinner"></div>
      </div>
    </div>
  );
};

export default Loader;

